import Swiper from 'swiper';
import { Navigation } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';

const testimonialsWrappers = document.querySelectorAll('.testimonials')

const sliders = [];

if (testimonialsWrappers.length > 0) {
  testimonialsWrappers.forEach(testimonialsWrapper => {
    sliders.push(new Swiper(testimonialsWrapper, {
      modules: [Navigation],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
          slidesPerGroup: 2
        }
      },
      loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1
    }));
  })
}
